import "@/App.css";
import LandingPage from "@/components/LandingPage";
import ContactForm from "@/components/ContactForm";
import ProductsPage from "@/components/ProductsPage";

function App() {
  if (/^\/produits\/?$/.test(window.location.pathname)) {
    return <ProductsPage />;
  }

  return (
    <>
      <LandingPage />
      <ContactForm />
    </>
  );
}

export default App;
